// Local imports
import * as config from './config.js';
import { detect_device } from '../device/index.js';
import { init_events } from './event.js';
import { PAGE_VARS, PageKind } from '../page/vars.js';

import { initialize as initialize_donation } from './data/donation.js';
import { initialize as initialize_product } from './data/product.js';
import { initialize as initialize_spsh } from './data/sponsorship.js';
import { initialize as initialize_gc } from './data/gift_catalogue.js';
import { initialize as initialize_cart } from './data/cart.js';
import { initialize as initialize_checkout } from './data/checkout.js';
import { initialize as initialize_siteheader } from './data/site_header.js';

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'datalayer_dispatch';

// Re-exports
export let global_vars = {};

export function init_globals(global) {
    let utag_data = {};

    let useragent = global.navigator.userAgent.toLowerCase();
    config.set_device(detect_device(useragent));

    // Initialize datalayer
    // GA4 implementation
    //global.utag_data = utag_data;
    return utag_data;
}

export function init_datalayer(global, handlerfunc, update_data) {
    // This function will create global.utag_data object
    let utag_data = init_globals(global);

    // Setup event
    const events = init_events(global);

    let data = {
        utag_data,
        events,
    };

    // Setup data layer handlers
    handlerfunc(global, data);

    // Initialize datalayer
    update_data(
        global,
        data.utag_data,
        global.location.href,
        global.document.title
    );
}

export function push_utag_data(utag_data) {
    window.dataLayer.push({
        event: 'shopify_data',
        data: utag_data,
    });
}

export function initialize(global) {
    //initialize site header link click event tracking
    initialize_siteheader(global);

    let page_kind = PAGE_VARS.kind;
    if (page_kind === PageKind.Donation) {
        initialize_donation(global);
    } else if (page_kind === PageKind.Product) {
        initialize_product(global);
    } else if (
        page_kind === PageKind.Sponsorship ||
        page_kind === PageKind.EventsApp
    ) {
        initialize_spsh(global);
    } else if (page_kind === PageKind.GiftCatalogue) {
        initialize_gc(global);
    } else if (page_kind === PageKind.Cart) {
        initialize_cart(global);
    } else if (page_kind === PageKind.Checkout) {
        initialize_checkout(global);
    }
}
